import navigation from "./navigation";
import NavigationAction from "./navigationAction";
import NavigationMenu from "./navigationDropdown";
import NavigationLink, { NavigationItem } from "./navigationLink";
import NavigationPrimary from "./navigationPrimary";
import NavigationSecondary from "./navigationSecondary";
import NavigationSection from "./navigationSection";

export type { NavigationActionProps } from "./navigationAction";
export type {
  NavigationMenuItemProps,
  NavigationMenuProps,
} from "./navigationDropdown";
export type { NavigationItemProps } from "./navigationLink";
export type { NavigationPrimaryProps } from "./navigationPrimary";
export type { NavigationSectionProps } from "./navigationSection";

const Navigation = Object.assign(navigation, {
  Primary: NavigationPrimary,
  Secondary: NavigationSecondary,
  Section: NavigationSection,
  Menu: NavigationMenu,
  Action: NavigationAction,
  Link: NavigationLink,
  Item: NavigationItem,
});

export default Navigation;
